import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  getCheckoutMetaApi,
  getCheckoutPaymentMethodsApi,
  checkoutApi,
  updateDeliveryDetailsApi,
  getStoreOrderMetaDataApi,
  updateCheckoutMetaApi
} from 'api/fesc/client'
import {
  previewModeGetCheckoutMetaApi,
  previewModeCheckoutApi
} from 'api/fesc/previewModeClient'
import { STORE_KEY as CHECKOUT_STORE_KEY } from './constants'
import * as C from './constants'
import { createValidationPayload } from 'tools/voucher'
import { getListOfVouchersApi, validateVoucherApi } from 'api/voucherify/client'

export const syncStoreOrderVoucher = (action) => (...params) => async (dispatch) => {
  try {
    const { payload } = await dispatch(action(...params))
    const { meta } = payload || {}
    const { storeOrder } = meta || {}
    const { orderVouchers } = storeOrder || {}
    const orderVoucher = (orderVouchers || [])[0]
    dispatch(setSelectedVoucherAction(orderVoucher))
    return payload || {}
  } catch (_) {
    // fail gracefully
  }
}

export const fetchCheckoutMetaAction = ({ req = null, storeOrderId }) => syncStoreOrderVoucher(
  asyncAction({
    getApi: () => {
      return storeOrderId === 'preview' ? previewModeGetCheckoutMetaApi : getCheckoutMetaApi
    },
    requestAction: C.GET_CHECKOUT_META_REQUEST,
    successAction: C.GET_CHECKOUT_META_SUCCESS,
    failureAction: C.GET_CHECKOUT_META_FAILURE
  })
)(() => {
  return { storeOrderId, req }
})

export const fetchCheckoutPaymentMethodsAction = asyncAction({
  api: getCheckoutPaymentMethodsApi,
  requestAction: C.GET_CHECKOUT_PAYMENT_METHODS_REQUEST,
  successAction: C.GET_CHECKOUT_PAYMENT_METHODS_SUCCESS,
  failureAction: C.GET_CHECKOUT_PAYMENT_METHODS_FAILURE
})

export const checkoutAction = asyncAction({
  getApi: (getState) => {
    const previewMode = getState()['@customisation'].data.previewMode
    return previewMode ? previewModeCheckoutApi : checkoutApi
  },
  requestAction: C.CHECKOUT_REQUEST,
  successAction: C.CHECKOUT_SUCCESS,
  failureAction: C.CHECKOUT_FAILURE
})

export const updateDeliveryDetailsAction = asyncAction({
  api: updateDeliveryDetailsApi,
  requestAction: C.UPDATE_DELIVERY_DETAILS_REQUEST,
  successAction: C.UPDATE_DELIVERY_DETAILS_SUCCESS,
  failureAction: C.UPDATE_DELIVERY_DETAILS_FAILURE
})

export const getStoreOrderMetaDataAction = asyncAction({
  api: getStoreOrderMetaDataApi,
  requestAction: C.GET_STORE_ORDER_META_DATA_REQUEST,
  successAction: C.GET_STORE_ORDER_META_DATA_SUCCESS,
  failureAction: C.GET_STORE_ORDER_META_DATA_FAILURE
})

export const getListOfVouchersAction = ({ req }) => asyncAction({
  api: getListOfVouchersApi,
  requestAction: C.GET_LIST_OF_VOUCHERS_REQUEST,
  successAction: C.GET_LIST_OF_VOUCHERS_SUCCESS,
  failureAction: C.GET_LIST_OF_VOUCHERS_FAILURE
})((getState) => {
  const checkoutState = getState()[CHECKOUT_STORE_KEY]
  return {
    // adjustDecimal is set to false as it will be handled by the Oddle Shop server
    ...(
      createValidationPayload(checkoutState.meta.data, false)
    ),
    req
  }
})

export const validateVoucherAction = ({ req, code }) => asyncAction({
  api: validateVoucherApi,
  requestAction: C.VALIDATE_VOUCHER_REQUEST,
  successAction: C.VALIDATE_VOUCHER_SUCCESS,
  failureAction: C.VALIDATE_VOUCHER_FAILURE
})((getState) => {
  const checkoutState = getState()[CHECKOUT_STORE_KEY]
  return {
    // adjustDecimal is set to false as it will be handled by the Oddle Shop server
    ...(
      createValidationPayload(checkoutState.meta.data, false)
    ),
    code,
    req
  }
})

export const setSelectedVoucherAction = (selectedVoucher) => ({ type: C.SET_SELECTED_VOUCHER, payload: { selectedVoucher } })

export const removeSelectedVoucherAction = () => ({ type: C.REMOVE_SELECTED_VOUCHER })

export const storeCheckoutAddressAction = (data) => ({ type: C.STORE_CHECKOUT_ADDRESS_INFO, payload: data })

export const selectSavedCreditCardAction = (data = {}) => ({ type: C.SELECTED_SAVED_CREDIT_CARD, payload: data })

export const updateCheckoutMetaAction = ({payload, storeOrderId }) => asyncAction({
  api: updateCheckoutMetaApi,
  requestAction: C.UPDATE_CHECKOUT_META_REQUEST,
  successAction: C.UPDATE_CHECKOUT_META_SUCCESS,
  failureAction: C.UPDATE_DELIVERY_DETAILS_FAILURE
})((getState) => {
  return {
    payload,
    storeOrderId
  }
})
